import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { ContainerColor, IconColor } from '../avatar/avatar.component';

@Component({
  selector: 'app-details-header',
  templateUrl: './details-header.component.html',
  styleUrls: ['./details-header.component.scss']
})
export class DetailsHeaderComponent implements OnInit {
  @Input() type?: string;
  @Input() header?: string;
  @Input() icon?: string;
  @Input() useEdit: boolean = true;
  @Input() showClose: boolean = true;
  @Input() containerColor: ContainerColor = 'primary-lighter';
  @Input() iconColor: IconColor = 'primary';

  @Output() onEdit = new EventEmitter<void>();

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {}
}
